export function formatPrice(value) {
    if (!Number.isFinite(value))
        return "0.00";
    const abs = Math.abs(value);
    if (abs >= 1000) {
        return value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    if (abs >= 1) {
        return value.toFixed(2);
    }
    return value.toFixed(4);
}
export class PriceLineRenderer {
    render(ctx, options) {
        const { plotBounds, y } = options;
        // W0 Task 0.3: the badge gutter follows the price-slot side;
        // legacy callers keep passing rightAxisBounds only.
        const rightAxisBounds = options.badgeAxisBounds ?? options.rightAxisBounds;
        if (!Number.isFinite(y))
            return;
        // Must be within visible vertical bounds
        if (y < plotBounds.top || y > plotBounds.top + plotBounds.height) {
            return;
        }
        const isBull = options.isBullish ?? true;
        const defaultColor = isBull ? "#089981" : "#f23645";
        const lineColor = options.color ?? defaultColor;
        const badgeBg = options.badgeBgColor ?? lineColor;
        const badgeText = options.badgeTextColor ?? "#ffffff";
        const lineDash = options.lineDash ?? [4, 4];
        const lineWidth = options.lineWidth ?? 1;
        const text = options.formattedPrice ?? (options.price !== undefined ? formatPrice(options.price) : "");
        ctx.save();
        // 1. Draw horizontal dashed price line across plot area
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        ctx.setLineDash(lineDash);
        ctx.beginPath();
        ctx.moveTo(plotBounds.left, y);
        ctx.lineTo(plotBounds.left + plotBounds.width, y);
        ctx.stroke();
        // 2. Draw price badge on the right axis
        if (rightAxisBounds && text) {
            ctx.setLineDash([]);
            ctx.font = "500 9px Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
            let textWidth = 32;
            try {
                const metrics = ctx.measureText(text);
                if (metrics && typeof metrics.width === "number" && metrics.width > 0) {
                    textWidth = metrics.width;
                }
            }
            catch {
                textWidth = text.length * 5.2;
            }
            const paddingX = 3;
            const badgeH = 15;
            const badgeW = Math.max(34, textWidth + paddingX * 2);
            const rightEdge = rightAxisBounds.left + rightAxisBounds.width - 2;
            let badgeX = Math.round(rightAxisBounds.left + (rightAxisBounds.width - badgeW) / 2);
            if (badgeX + badgeW > rightEdge) {
                badgeX = rightEdge - badgeW;
            }
            const badgeY = Math.round(y - badgeH / 2);
            ctx.fillStyle = badgeBg;
            ctx.beginPath();
            if (typeof ctx.roundRect === "function") {
                ctx.roundRect(badgeX, badgeY, badgeW, badgeH, 2);
            }
            else {
                ctx.rect(badgeX, badgeY, badgeW, badgeH);
            }
            ctx.fill();
            ctx.fillStyle = badgeText;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(text, Math.round(badgeX + badgeW / 2), y);
        }
        ctx.restore();
    }
}
